// Owner: task-actions (owner feedback F14). The `finish-task` layer: the finishing dialog of a task opened from a
// quick control that cannot show it. Loads on first open (`features/task-actions/events.ts` opens it).
import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';
import '../features/task-actions/events';

export default defineGlobalLayer({
  id: 'finish-task',
  component: lazy(() => import('../features/task-actions/FinishTaskLayer')),
});
